import {
	Button,
	Input,
	Select,
	VStack,
} from '@montel/montelpro-shared-components-v2';
import { styled } from 'styled-components';

export const StyledInput = styled(Input)`
	width: 60%;
`;

export const StyledSelect = styled(Select)`
	width: 40%;
`;

export const StyledButton = styled(Button)`
	align-self: flex-end;
`;

export const FormContainer = styled(VStack)`
	max-width: 800px;
`;
